import { defaultInstance } from 'src/api/instance';
import { configVars } from 'src/helpers';

const api = {
  getAccess: async (dashboardId: string): Promise<{ allowed: boolean }> =>
    defaultInstance.get(`${configVars.server_url}/v2/databricks/access?dashboard_id=${dashboardId}`)
};

export default api;
